import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Patient } from 'src/app/core/models/patient/patient';

@Injectable({
  providedIn: 'root'
})
export class PatientSelectorService {

  private selectedPatient: Patient;
  selectionChange$: Subject<Patient> = new Subject<Patient>();

  constructor() { }

  setPatient(patient: Patient): void {
    this.selectedPatient = patient;
    this.selectionChange$.next(patient);
  }

  getPatient(): Patient {
    return this.selectedPatient;
  }

  removePatient(): void {
    this.selectedPatient = undefined;
    this.selectionChange$.next(undefined);
  }
}
